import { defineChain } from '@reown/appkit/networks'
import { AppKitNetwork } from '@reown/appkit/networks'

export const arbitrumChain: AppKitNetwork = /*#__PURE__*/ defineChain({
  id: 42161,
  name: 'Arbitrum One',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://arbitrum-rpc.mtt.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Arbiscan',
      url: 'https://arbiscan.io',
      apiUrl: 'https://api.arbiscan.io/api',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 7654707,
    },
  },
  chainNamespace: 'eip155',
  caipNetworkId: 'eip155:42161',
}) as AppKitNetwork
